/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-12-08 16:29:09
 * @LastEditors: changfeng
 * @LastEditTime: 2022-12-08 16:29:23
 */
export default {
  AND: 'AND',
  OR: 'OR',
  NOT: 'NOT',
};
